import { type ReactNode } from 'react'
import { CompanyInfo } from 'app/components/CompanyInfo'
import { COMPANY_ICON_ID, isCustomIconId } from '@terros/common'
import { useProfile } from '@front/model'
import { type CommonIconDisplayProps } from './types'
import { IconEmojiDisplay } from './IconEmojiDisplay'

export type IconDisplayProps = {
  color?: string
  icon?: string
} & CommonIconDisplayProps

export const IconDisplay = ({ color, icon, size = 'md' }: IconDisplayProps): ReactNode => {
  const { company } = useProfile()
  if (isCustomIconId(icon)) {
    switch (icon) {
      case COMPANY_ICON_ID:
        if (!company) return
        return <CompanyInfo avatarOnly color={color} linked={false} size={size} {...company} />
      default:
        return
    }
  }

  return <IconEmojiDisplay color={color} icon={icon} size={size} />
}
